<template>
  <ListeFicheInventaire/>
</template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
    import ListeFicheInventaire from "@/components/GesCom/Inventaire/ListeFicheInventaire.vue";

    export default defineComponent({
      name: "ListeFicheInventairePage",
      components: {
        ListeFicheInventaire,
      },
    });
  </script>